import ImgsViewer from "@/components/ImagesViewer/ImgsViewer"
import React, {
  useImperativeHandle, useState 
} from "react"

// eslint-disable-next-line react/display-name
const ImagesViewerModal = React.forwardRef((props, ref) => {
  const {
    isOpen: propsIsOpen, images, index = 0 
  } = props

  const [isOpen, setIsOpen] = useState(propsIsOpen)

  const [currentIndex, setCurrentIndex] = useState(index)

  useImperativeHandle(ref, () => ({
    setIsOpen,
    setCurrentIndex,
  }))

  const gotoPrevImg = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1)
    }
  }

  const gotoNextImg = () => {
    if (currentIndex < images.length - 1) {
      setCurrentIndex(currentIndex + 1)
    }
  }

  const closeImgsViewer = () => {
    setIsOpen(false)
  }

  return (
    <ImgsViewer
      isOpen={isOpen}
      currImg={currentIndex}
      imgs={images}
      onClickPrev={gotoPrevImg}
      onClickNext={gotoNextImg}
      onClose={closeImgsViewer}
      backdropCloseable={true}
    />
  )
})

export default ImagesViewerModal
